/* eslint-disable no-shadow */
import { http } from "@/api";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import {
	GetRunTime,
	GetRunTimeError,
	GetRunTimeSuccess,

} from "@/stores/actions/RunTime";

const missingDataError = "Não há dados no período selecionado!";
const missingDataMessage = "Não foi possível calcular o tempo de atividade no período selecionado.";
const badDataError = "Ocorreu um problema.";
const badDataMessage = "Ocorreu um problema na leitura dos dados. Já estamos trabalhando para resolver o problema!";

const state = {
	status:         FetchStatus.Init,
	successMessage: "",
	errorMessage:   "",
	data:           {},
};

const actions = {

	[GetRunTime]: ({ commit }, params) => new Promise((resolve, reject) =>
	{
		const { startId } = params;
		const { stopId } = params;
		const { startDate } = params;
		const { stopDate } = params;
		const url = `/GeneratingUnitsOperatingTime?startEventSettingId=
		${startId}&stopEventSettingId=${stopId}&startDate=${startDate}&endDate=${stopDate}`;
		http.get(url)
			.then((resp) =>
			{
				commit(GetRunTimeSuccess, resp);
				resolve(resp);
			})
			.catch((error) =>
			{
				commit(GetRunTimeError, error.response);
				reject(error);
			});
	}),
};
const mutations = {
	[GetRunTime]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GetRunTimeSuccess]: (state, resp) =>
	{
		state.data = resp.data;
		state.status = FetchStatus.Loaded;
	},
	[GetRunTimeError]: (state, error) =>
	{
		state.errorMessage = (error.status === 400 ? missingDataMessage : badDataMessage);
		state.errorHead = (error.status === 400 ? missingDataError : badDataError);
		state.error = error.response;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
